// extracted by mini-css-extract-plugin
module.exports = {"customCheckbox":"FlatsTable_customCheckbox__UxTq_"};